// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___eBkCZ","root__avatar":"style-module__root__avatar___dz_JM","root__wrapper":"style-module__root__wrapper___IJ_Sn","root__wrapper_list__wrapper":"style-module__root__wrapper_list__wrapper___VSFuN","root__wrapper_list__item":"style-module__root__wrapper_list__item___vEVmE","root__btn":"style-module__root__btn___dx4MJ"};
    if(module.hot) {
      // 1729151126160
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  